import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Lightbulb, Rocket, Clock } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useTx, isWaiting } from "@/components/PaymentPanel";
import { CoachingCard } from "@/pages/ExpertCoaching";

const rs = (n) => `Rs ${Number(n).toLocaleString("en-US")}`;
const Owned = ({ children }) => <span className="sb-chip bg-[#E8F8F4] text-[#179B80]"><CheckCircle2 className="h-3.5 w-3.5" />{children}</span>;

export function OffersRow() {
  const tx = useTx();
  const { can } = useAuth();
  const [b, setB] = useState(null);
  const [c, setC] = useState(null);
  const [g, setG] = useState(null);
  useEffect(() => {
    api.get("/upgrade/builder").then((r) => setB(r.data));
    api.get("/upgrade/coaching").then((r) => setC(r.data));
    api.get("/public/offer").then((r) => setG(r.data));
  }, []);
  if (!b || !c) return null;
  return (
    <section data-testid="home-offers">
      <div className="sb-eyebrow mb-3">{tx("YOUR SIDEBIZZ PLANS", "VOS OFFRES SIDEBIZZ")}</div>
      <div className="grid md:grid-cols-3 gap-4">
        <div className="sb-card p-5 flex flex-col" data-testid="offer-card-ideas">
          <div className="flex items-center justify-between"><span className="sb-eyebrow">Business Ideas</span><Lightbulb className="h-5 w-5 text-[#1DB99A]" /></div>
          <div className="font-display text-2xl font-extrabold mt-1">{g ? rs(g.price) : "—"}</div>
          <p className="text-sm text-[#5C6B73] mt-2 flex-1">{tx("150+ business ideas for Mauritius, with costs, customers and first steps.", "150+ idées de business pour Maurice, avec coûts, clients et premières étapes.")}</p>
          <div className="mt-4 flex items-center justify-between gap-2"><Owned>{tx("You have it", "Vous l’avez")}</Owned><Link to="/ideas" className="text-sm font-bold text-[#179B80]">{tx("Open ideas", "Voir les idées")}</Link></div>
        </div>
        <div className={`sb-card p-5 flex flex-col ${b.has_access ? "" : "ring-2 ring-[#1DB99A]"}`} data-testid="offer-card-builder">
          <div className="flex items-center justify-between"><span className="sb-eyebrow">Business Builder</span><Rocket className="h-5 w-5 text-[#1DB99A]" /></div>
          <div className="font-display text-2xl font-extrabold mt-1" data-testid="offer-builder-price">{rs(b.price)}<span className="text-sm font-semibold text-[#5C6B73]">/{tx("year", "an")}</span></div>
          {!b.has_access && <span className="text-[11px] font-bold text-[#179B80] mt-1">{tx("RECOMMENDED NEXT STEP", "PROCHAINE ÉTAPE CONSEILLÉE")}</span>}
          <p className="text-sm text-[#5C6B73] mt-2 flex-1">{tx("The step-by-step course plus your personal 9-stage Launch Plan.", "Le cours pas à pas et votre plan de lancement personnel en 9 étapes.")}</p>
          <div className="mt-4">{b.has_access ? <div className="flex items-center justify-between gap-2"><Owned>{tx("Active", "Actif")}</Owned><Link to="/launch" className="text-sm font-bold text-[#179B80]">{tx("Launch Plan", "Plan de lancement")}</Link></div>
            : isWaiting(b.request) ? <span className="sb-chip bg-amber-50 text-amber-700" data-testid="offer-builder-waiting"><Clock className="h-3.5 w-3.5" />{tx("Waiting for Payment Approval", "En attente de validation")}</span>
            : <Link to="/upgrade" className="sb-btn-primary w-full" data-testid="offer-builder-cta">{tx("Start My Business", "Lancer mon business")}</Link>}</div>
        </div>
        <CoachingCard d={c} compact={!can("builder")} />
      </div>
    </section>
  );
}
